export default "/_next/static/assets/DunbarTall-Regular_9b203ac0da4ae68eb3f1e1e4912e18d3.woff2";